/**
 * The `page_touch` event's name and its one property, apart from the sender
 * (utils/page-touch.ts) so the track schema and the SQL readers can name it
 * without pulling the browser tracker in.
 */
export const PAGE_TOUCH_EVENT = 'page_touch';

/** What the first touch was. */
export const PAGE_TOUCH_VIA = ['pointer', 'key', 'scroll', 'wheel', 'touch'] as const;
export type PageTouchVia = (typeof PAGE_TOUCH_VIA)[number];
